<template lang="html">

  <span class="pe_stop-watch">
    <icon-clock /> <!--{{ formattedTotalTime }} --> {{ adjustedTotalTime }} 
  </span>

</template>

<script lang="js">

  import { mapActions, mapState, mapGetters } from 'vuex'
  import Clock from '@puzzleapps/shared/src/components/ui/icons/Clock'

  export default  {
    name: 'stop-watch',
    props: ['localSave'],
    components: {
      'icon-clock': Clock,
    },

    data () {
      return {
        intervals: 500,
        timer: null,
        ticks: 0,
        lastTick: 0,
      }
    },

    methods: {
      ...mapActions({
        setTotalTime: 'game/setTotalTime',
        saveToLocal: 'game/saveToLocal',
      }),

      tick() {
        // TODO something is happening here after game is paused once
        if (!this.isPlaying) return

        let tickDelta = Date.now() - this.lastTick
        this.lastTick = Date.now()
        this.setTicks(this.ticks + tickDelta)

        // update vuex store
        this.setTotalTime(this.ticks)
        this.saveToLocal()

      },

      setTicks(val) {
        this.ticks = (!val) ? 0 : val
      },

      start() {
        this.ticks = this.totalTime
        if (!this.lastTick === 0)
          this.lastTick = Date.now() - this.totalTime
        else
          this.lastTick = Date.now()

        // TODO: is there a better way to save to local?
        // animation frame maybe or updating time from the store
        if (this.localSave)
          this.timer = setInterval(this.tick, this.intervals)
      },

      pause() {
        clearInterval(this.timer)
      },

      togglePause() {
        if (!this.isPlaying) this.start()
        else                 this.pause()      
      },
      // reset() {

      // },

    },

    // watch for isPlaying state changes
    watch: {
      isPlaying(newVal) {
        if (!newVal) this.pause()
        else this.start()
      },
    },

    computed: {
      ...mapState({
        totalTime: state => state.game.totalTime,
        isPlaying: state => state.game.isPlaying,
      }),

      ...mapGetters({
        formattedTotalTime: 'game/formattedTotalTime',
        adjustedTotalTime: 'game/formattedAdjustedTime'
      }),

      ...mapActions({
      setIsPlaying: 'game/setIsPlaying',

    }), 
    },
    

    destroyed() {
      clearInterval(this.timer)
    }
  }


</script>

<style scoped lang="scss">

  .pe_stop-watch {
    min-width: 5em;
    display: inline-flex;
    position: relative;
    align-items: center;

    .pe_clock {
      right: 100%;
      width: 13px;
      height: 13px;
      margin: 1px 5px 0 0;
    }

  }

</style>
